import React, { useEffect, useState } from 'react';
import { Content, Title, InputFormTable, Text } from 'components';
import { Button, Upload } from 'antd';
import { UploadOutlined, PictureOutlined } from '@ant-design/icons';

import styles from '../styles';
import MessageAlert from 'utils';
import { useProductImageDispatch } from '../context/ProductImageProvider';

const ProductImageInformation = ({ defaultData }) => {
  const [thumbnailImage, setThumbnailImage] = useState([]);
  const [productImages, setProductImages] = useState([]);
  const dispatch = useProductImageDispatch();

  useEffect(() => {
    dispatch({ type: 'CHANGE_PRODUCT_IMAGES', value: productImages });
  }, [productImages]);

  const customRequest = (options, type, fileSize) => {
    const { file, onSuccess, onError } = options;

    validateThumbnailSize(file, fileSize)
      .then(() => {
        const localUrl = URL.createObjectURL(file); // 브라우저 메모리에 파일 저장
        const fileData = {
          uid: file.uid,
          name: file.name,
          status: 'done',
          url: localUrl,
          file: file,
        };

        // 성공 콜백 호출
        onSuccess(fileData);

        if (type === 'thumbnail') {
          dispatch({ type: 'CHANGE_THUMBNAIL', value: fileData });
          setThumbnailImage([fileData]);
        } else if (type === 'product') {
          setProductImages(productImages.concat([fileData]));
        }
      })
      .catch((error) => {
        // 업로드 실패 처리
        onError(error);
        MessageAlert.error(error.message);
      });
  };

  const validateThumbnailSize = (file, fileSize) => {
    const expectedWidth = fileSize.width;
    const expectedHeight = fileSize.height;

    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = () => {
        // resolve(); // 이미지 크기가 맞으면 업로드 진행

        if (file.name.length > 50) {
          reject(
            new Error(
              '파일명은 50자를 초과할 수 없습니다. 변경 후 다시 시도해주세요.'
            )
          );
        } else {
          resolve();
        }

        // if (img.width === expectedWidth && img.height === expectedHeight) {
        //   resolve(); // 이미지 크기가 맞으면 업로드 진행
        // } else {
        //   reject(
        //     new Error(
        //       `이미지 크기가 ${expectedWidth}px x ${expectedHeight}px이어야 합니다.`
        //     )
        //   );
        // }
      };

      img.onerror = () => {
        reject(new Error('이미지를 로드하는 중 오류가 발생했습니다.'));
      };
    });
  };

  const handleChangeProductImage = (productImage) => {
    const filterdProductImages = productImages.filter((image) => {
      if (productImage.file.uid !== image.uid) {
        return true;
      }

      return false;
    });

    setProductImages(filterdProductImages);
  };

  const form = [
    {
      label: '썸네일 이미지',
      direction: 'column',
      form: [
        {
          input: (
            <Upload
              customRequest={(options) =>
                customRequest(options, 'thumbnail', {
                  width: 330,
                  height: 410,
                })
              }
              listType="picture"
              maxCount={1}
              fileList={thumbnailImage}
              beforeUpload={(file) => {
                return validateThumbnailSize(file, {
                  width: 330,
                  height: 410,
                })
                  .then(() => true)
                  .catch((error) => {
                    MessageAlert.error(error.message);
                    return Upload.LIST_IGNORE; // 업로드 중단
                  });
              }}
              accept="image/*"
            >
              <Button type="primary" icon={<UploadOutlined />}>
                썸네일 이미지 업로드
              </Button>
            </Upload>
          ),
        },
        {
          input: (
            <Text size={14} color={'#BDBDBD'}>
              상품목록에 표시되는 이미지입니다.
            </Text>
          ),
        },
      ],
    },
    {
      label: '상품 이미지',
      direction: 'column',
      form: [
        {
          input: (
            <Upload
              customRequest={(options) =>
                customRequest(options, 'product', { width: 705, height: 875 })
              }
              listType="picture"
              maxCount={1}
              fileList={productImages}
              onChange={handleChangeProductImage}
              beforeUpload={(file) => {
                return validateThumbnailSize(file, { width: 705, height: 875 })
                  .then(() => true)
                  .catch((error) => {
                    MessageAlert.error(error.message);
                    return Upload.LIST_IGNORE; // 업로드 중단
                  });
              }}
              accept="image/*"
            >
              <Button type="primary" icon={<UploadOutlined />}>
                상품 이미지 업로드
              </Button>
            </Upload>
          ),
        },
        {
          input: (
            <Text size={14} color={'#BDBDBD'}>
              상품상세페이지에 표시되는 이미지입니다.
            </Text>
          ),
        },
      ],
    },
  ];

  useEffect(() => {
    if (defaultData && Array.isArray(defaultData.product_file)) {
      // 1) 썸네일 데이터 추출
      const thumbnail = defaultData.product_file.find(
        (fileItem) => fileItem.type === 'THUMBNAIL'
      );

      if (thumbnail) {
        dispatch({
          type: 'CHANGE_THUMBNAIL',
          value: {
            uid: thumbnail.product_file_id,
            name: thumbnail.file_name,
            status: 'done',
            url: thumbnail.file_url,
            file: null, // 실제 File 객체는 없으므로 null 처리
          },
        });

        setThumbnailImage([
          {
            uid: thumbnail.product_file_id,
            name: thumbnail.file_name,
            status: 'done',
            url: `${process.env.REACT_APP_STORE_URL}/${thumbnail.file_url}`,
            file: null, // 실제 File 객체는 없으므로 null 처리
          },
        ]);
      }

      // 2) 상품 이미지 데이터 추출
      const productFileList = defaultData.product_file
        .filter((fileItem) => fileItem.type === 'PRODUCT')
        .map((fileItem) => ({
          uid: fileItem.product_file_id,
          name: fileItem.file_name,
          status: 'done',
          url: `${process.env.REACT_APP_STORE_URL}/${fileItem.file_url}`,
          file: null, // 실제 File 객체가 없으므로 null 또는 undefined
        }));

      // state에 세팅
      setProductImages(productFileList);
    }
  }, [defaultData]);

  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 25 }}
      className="boxShadow"
    >
      <Title size={5} align="left" style={{ marginBottom: 10 }}>
        <PictureOutlined /> 이미지 정보
      </Title>
      <InputFormTable form={form} />
    </Content>
  );
};

export default ProductImageInformation;
